import type { SxProps, Theme } from '@mui/material/styles';

// Hoisted so every render reuses the same objects.
export const pillButtonSx: SxProps<Theme> = {
  height: 40,
  px: 2,
  borderRadius: 20,
  fontWeight: 600,
  whiteSpace: 'nowrap',
};

export const smallPillButtonSx: SxProps<Theme> = {
  height: 36,
  px: 1.75,
  borderRadius: 18,
  fontWeight: 500,
  whiteSpace: 'nowrap',
};

export const monoSx: SxProps<Theme> = {
  fontFamily: '"IBM Plex Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
};

export const sectionLabelSx: SxProps<Theme> = {
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: 'text.secondary',
};
